"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_REVIEW_PAGINATION = exports.columns = exports.INITIAL_VISIBLE_COLUMNS = exports.validationConfig = exports.statusOptions = void 0;
exports.statusOptions = [
    { label: "Draft", value: "draft" },
    { label: "Published", value: "published" },
];
exports.validationConfig = {
    customer_name: { required: true, minLength: 2 },
    rating: { required: true, min: 1, max: 5 },
    review_text: { required: true, minLength: 5 },
    date: { required: true },
    status: { required: true },
};
exports.INITIAL_VISIBLE_COLUMNS = ["customer_name", "rating", "review_text", "date", "status", "actions"];
exports.columns = [
    { name: "Customer Name", uid: "customer_name", sortable: true },
    { name: "Rating", uid: "rating", sortable: true },
    { name: "Review", uid: "review_text", sortable: false },
    { name: "Date", uid: "date", sortable: true },
    { name: "Status", uid: "status", sortable: true },
    { name: "Actions", uid: "actions", sortable: false },
];
exports.DEFAULT_REVIEW_PAGINATION = {
    page: 1,
    size: 10,
    countTotal: 0,
};
